import Api from "../../../config/api";
import {
  CREATE_REQUEST_INVOICE,
  SEARCH_REQUEST_INVOICE,
  SEARCH_REQUEST_INVOICE_BY_ID,
  UPDATE_REQUEST_INVOICE,
} from "../../../utils/constants";
import { showToast } from "../../toast/ShowToast";

export const getRequestInvoice = async (params?: any) => {
  try {
    const res = await Api(false).get(SEARCH_REQUEST_INVOICE, { params });
    return res;
  } catch (error: any) {
    if (error?.response?.status >= 400 && error?.response?.status <= 499) {
      showToast(`${error.response.statusText}`, "error");
    } else {
      showToast(`${error?.response?.data?.message}`, "error");
    }
  }
};

export const getRequestInvoiceById = async (id?: string) => {
  try {
    const res = await Api(false).get(`${SEARCH_REQUEST_INVOICE_BY_ID}/${id}`);
    return res;
  } catch (error: any) {
    if (error?.response?.status >= 400 && error?.response?.status <= 499) {
      showToast(`${error.response.statusText}`, "error");
    } else {
      showToast(`${error?.response?.data?.message}`, "error");
    }
  }
};

export const createRequestInvoice = async (
  body: any,
  hideLoader: () => void
) => {
  try {
    const res = await Api(false).post(CREATE_REQUEST_INVOICE, body);
    return res;
  } catch (error: any) {
    if (error?.response?.status >= 400 && error?.response?.status <= 499) {
      showToast(`${error.response.statusText}`, "error");
    } else {
      let msg = error?.response?.data?.message.split(":");
      if (msg[2] === " invoiceNumber_1_company_1 dup key") {
        showToast(`RequestInvoice number already taken`, "error");
        hideLoader();
        return error;
      } else {
        showToast(`${error?.response?.data?.message}`, "error");
        hideLoader();
      }
    }
  }
};

export const updateRequestInvoice = async (
  body: any,
  id: string,
  hideLoader: () => void
) => {
  try {
    const res = await Api(false).put(`${UPDATE_REQUEST_INVOICE}/${id}`, body);
    return res;
  } catch (error: any) {
    if (error.response.status >= 400 && error.response.status <= 499) {
      showToast(`${error.response.statusText}`, "error");
      hideLoader();
    } else {
      showToast(`${error.response.data.message}`, "error");
      hideLoader();
    }
  }
};
